import React from 'react'

import './index.scss'

const Dots = ({ selected, number }) => (
  <div className={selected > number ? "dots dots--visible" : selected === number ? "dots dots--selected" : "dots"}>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="6" />
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="6" />
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="6" />
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="6" />
    </svg>
  </div>
)

export default Dots
